export default {
  index: [
    // {
    //   path: '/expenditure',
    //   component: resolve => require(['./expenditureIndex.vue'], resolve),
    // },


    {
      path: '/expenditure',
      component: resolve => require(['./expenditureIndexcopy.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/expenditure/_router.js